import React, { FunctionComponent } from 'react';
import { useStore } from 'effector-react';
import authStore, { logout } from '@stores/auth';
import { LogoutOutlined } from '@ant-design/icons';
import css from './UserBlock.module.less';

interface UserBlockProps { }

const UserBlock: FunctionComponent<UserBlockProps> = () => {
  const auth = useStore(authStore);

  return (
    <div className={css.root}>
      <div>{auth.user ? auth.user.email : null}</div>
      <div className={css.icon} onClick={() => logout()}>
        <LogoutOutlined />
      </div>
    </div>
  );
};

export default UserBlock;
